<template>
    <div v-if="computedUsedFor">
        {{ $tm(computedUsedFor) }}
    </div>
</template>
<script setup lang="ts">
import type { GPIOReadingUsedFor } from '@/objects/generated';
import { computed } from 'vue';

const prop = defineProps<{
    value?: GPIOReadingUsedFor;
}>();

const computedUsedFor = computed(() => {
    return 'gpioreadingusedfor.' + prop.value?.toString()?.toLowerCase();
});
</script>
